import { createRouter, createWebHashHistory } from 'vue-router'
import routes from './routes'
import store from '@/store'
import * as InfoApi from '@/api/Info'

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: function () {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.path === '/sign' || to.path === '/usepc') {
    next()
  } else if (Object.keys(store.state.userInfo).length) {
    next()
  } else {
    InfoApi.getUserInfo().then((res) => {
      if (res.error === 10002) {
        next('/sign')
      } else {
        store.state.userInfo = res.ret.info
        next()
      }
    })
  }
})

export default router
